import { render, staticRenderFns } from "./noticeMessage.vue?vue&type=template&id=35fda26d&scoped=true"
import script from "./noticeMessage.vue?vue&type=script&lang=js"
export * from "./noticeMessage.vue?vue&type=script&lang=js"
import style0 from "./noticeMessage.vue?vue&type=style&index=0&id=35fda26d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fda26d",
  null
  
)

export default component.exports